import { render, staticRenderFns } from "./TutorialsAdmin.vue?vue&type=template&id=736d696a&scoped=true&"
import script from "./TutorialsAdmin.vue?vue&type=script&lang=js&"
export * from "./TutorialsAdmin.vue?vue&type=script&lang=js&"
import style0 from "./TutorialsAdmin.vue?vue&type=style&index=0&id=736d696a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736d696a",
  null
  
)

export default component.exports